<template>
  <div class="Main-Inner">
    <div class="Main-Sidebar-Wrapper">
      <div class="Main-Sidebar">
        <ul class="nav" id="dashboard-nav">
          <li class="section">{{$t('Campaign')}}</li>
          <router-link tag="li" :to="{ path: `/campaigns/${campaignId}/details/` }" active-class="active"><a class="nav-link">{{$t('General')}}</a></router-link>
          <router-link tag="li" :to="{ path: `/campaigns/${campaignId}/offers/` }" active-class="active"><a class="nav-link">{{$t('Offers')}}</a></router-link>
          <router-link tag="li" :to="{ path: `/campaigns/${campaignId}/segmentation/` }" active-class="active"><a class="nav-link">{{$t('Segmentation')}}</a></router-link>
          <router-link tag="li" :to="{ path: `/campaigns/${campaignId}/domains/` }" active-class="active"><a class="nav-link">{{$t('Domains')}}</a></router-link>
          <router-link tag="li" :to="{ path: `/campaigns/${campaignId}/options/` }" active-class="active"><a class="nav-link">{{$t('Options')}}</a></router-link>
          <router-link tag="li" :to="{ path: `/campaigns/${campaignId}/publish/` }" active-class="active"><a class="nav-link">{{$t('Publish')}}</a></router-link>
        </ul>
      </div>
    </div>
    <router-view v-if="!loading"></router-view>
    
  </div>
</template>

<script>

export default {
  name: 'Campaigns',
  data() {
    return {
      loading: true,
      campaignId: null
    }
  },
  async mounted() {
    this.campaignId = parseInt(this.$route.params.id)
    this.$watch('$route.params.id', (newVal) => {
      this.campaignId = newVal
    })
    this.loading = false
  }
}
</script>

<style lang="scss">
.Content-Box.actions .btn-success {
  float: right;
}
</style>